module.exports = __webpack_public_path__ + "img/partners_right.12a1ef60.svg";